import { render, staticRenderFns } from "./AntiSpamSettings.vue?vue&type=template&id=239d97f0&scoped=true"
import script from "./AntiSpamSettings.vue?vue&type=script&lang=js"
export * from "./AntiSpamSettings.vue?vue&type=script&lang=js"
import style0 from "./AntiSpamSettings.vue?vue&type=style&index=0&id=239d97f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d97f0",
  null
  
)

export default component.exports